import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Spin, Button } from 'antd'
import {withTranslation} from 'react-i18next'
import ViewSearchForm from './ViewSearchForm'
import ViewSearchResult from './ViewSearchResult'

@inject('emailAddressStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  render() {
    const { emailAddressStore, addModalVisible, handleCancel, t, record } = this.props
    const { isFetchingDetails } = emailAddressStore
    return (
      <>
        <Modal
          title={`${t('emailSend.addressDetails')}`}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'50%'}
          centered
          footer={false}
        >
          <Spin spinning={isFetchingDetails}>
            <ViewSearchForm record={record} />
            <ViewSearchResult listId={record?.id} />
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
